import React from "react";
import "./footersolutioncard.css";

function FooterSolutionCard() {
  return (
    <div className="footer-solution-card-container">
      <img
        src="/images/footer-solution-card.svg"
        alt=""
        loading="lazy"
        decoding="async"
      />
      <div className="footer-solution-card-container-text">
        {/* Leading provider of solutions for NBFCs, Fintech, RegTech, and Banks to
        transform how MSMEs and individuals are onboarded, while enhancing data
        experiences. */}
        Helping NBFCs, Fintechs, RegTechs, and Banks simplify MSME and
        individual onboarding—through document analysis, face match, and
        tampering detection.
      </div>
    </div>
  );
}

export default React.memo(FooterSolutionCard);
